import ComponentManager from '@/Management/ComponentManager';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import * as CoreFrameDTOs from "coreframetypings/dto";
import DetailViewViewModel from '@/ViewModels/Views/DetailViewViewModel';
import NavigationHelper from '@/Management/NavigationHelper';
import Utilities from '@/Utility/Utilities';
import { IRefreshable } from '#/DefaultViewExtensionInterfaces';

export default class CreateAndConnectLinkViewModel extends ToolBarLinkViewModel {

    protected listView: KnockoutObservable<CoreFrameDTOs.IListViewDTO>;
    protected contextPdoId: KnockoutObservable<any>;
    protected contextTypeName: KnockoutObservable<string>;
    protected contextRelationName: KnockoutObservable<string>;
    protected typeName: KnockoutObservable<string>;
    protected dataSource: IRefreshable;
    protected navigateOnCreate: boolean;

    public constructor(protected params: any) {
        super($.extend(params,
            {
                ergName: 'CREATE_NEW_AND_CONNECT',
                tooltipErgName: 'CREATE_NEW_AND_CONNECT_TOOLTIP',
                imageSource: GlobalConfiguration.inlineImages.TOOLBAR_CREATE,
                locator: 'create'
            }));

        this.setRequiredObservables();

        this.contextPdoId = this.observableOrDefault(params.contextPdoId, this.context.genericObject.pdoId);
        this.contextTypeName = this.observableOrDefault(params.contextTypeName, this.context.genericObject.pdTypeName);

        if (params.pdTypeName)
            this.typeName = this.observableOrDefault(params.pdTypeName);
        else
            this.typeName = this.defineComputed(() => this.listView().typeName);

        if (params.contextRelationName)
            this.contextRelationName = this.observableOrDefault(params.contextRelationName);
        else
            this.contextRelationName = this.defineComputed(() => this.listView().relationName);
        this.navigateOnCreate = this.paramOrDefault(params.navigateOnCreate, true);
        this.dataSource = this.paramOrDefault(params.dataSource, null);
    }

    /**
     * @override 
     */
    protected createIsVisibleObservable(): KnockoutObservable<boolean> {
        if (!Utilities.isNullOrUndefined(this.params.isVisible)) {
            return this.observableOrDefault(this.params.isVisible);
        }

        this.setRequiredObservables();

        return this.createWritableComputed(() => !this.params.context?.isSummaryViewMode() && this.listView().showButtonCreate);
    }

    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.listView().relationName, 'connect', { toPdoIds: [null] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    const callback = () => {
                        return this.create(this.typeName(), this.contextPdoId(), this.contextTypeName(), this.contextRelationName())
                            .then((result) => {
                                return this.createCallback(result);
                            });
                    }

                    if (this.navigateOnCreate) {
                        (this.context.viewModel as DetailViewViewModel).confirmCreateContext((success) => {
                            if (!success)
                                return undefined;

                            return callback();
                        });
                    }
                    else {
                        callback();
                    }
                }
            });
    }

    protected create(pdTypeName: string, contextPdoId: string, contextTypeName: string, contextRelationName: string): JQuery.Promise<boolean> {
        NavigationHelper.openDetailViewAndConnect('EDIT',
            pdTypeName,
            contextPdoId,
            contextTypeName,
            contextRelationName);

        return Utilities.resolveImmediately(true);
    }

    protected createCallback(couldCreate: boolean): void {
        if (!this.navigateOnCreate) {
            this.dataSource?.refresh();
            this.context.genericObject.isModified(true);
        }
    }

    /**
     * Da bereits im Konstruktor der Oberklassen Methoden aufgerufen werden, die auf Member dieser Klasse zugreifen
     * muss dies in eine Methode ausgelagert werden
     */
    protected setRequiredObservables(): void {
        if (Utilities.isNullOrUndefined(this.listView)) {
            this.listView = this.observableOrDefault(this.params.listView);
        }
    }
}

ComponentManager.setViewModel('CreateAndConnectLink', CreateAndConnectLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');